<template>
  <div class="ProductInfo">
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane label="产品选择" >
        <span slot="label"><p class="el-icon-arrow-left back-icon" @click="back()"></p> 产品选择 </span>
        <div>
          <el-tabs class="disflex" tab-position="left" v-model="selectedType" :stretch="true" @tab-click="selectTypeClick">
            <el-tab-pane  :label=type v-for="(type,i) in types" :key="i" :name="type">
              <el-input placeholder="请搜索关键字" v-model="search">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-table stripe :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))">
                <el-table-column
                  prop="name">
                </el-table-column>
                <el-table-column width="40px"
                  align="left">
                  <template align="right" slot-scope="{row}">
                    <el-button type="primary" size="mini"
                      @click="handleEdit(row)" icon="el-icon-check" plain circle></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
          <el-dialog
              :title="s_product.model"
              :visible.sync="dialogVisible"
              :modal-append-to-body='false'
              width="90%">
            <img :src="hqImgUrl" alt="" class="product-img-hq">
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="chooseProduct">选择此产品</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
    export default {
        name: "ProductInfo",
        data(){
          return{
            s_product: {type: '' , series: '' , model: '' , img: ''},   // 选择产品返回的参数
            types: ['智能门锁', '晾衣机', '智能窗帘', '浴霸', '凉霸', '风扇灯', '吸顶灯', '吊灯', '智能开关'],    // 产品类型
            series: [],   // 产品系列
            selectedType:'智能门锁',    // 选择的产品类型
            productName: '',
            dialogVisible: false,   // 控制 el-dialog 显示隐藏的参数
            hqImgUrl: '',   // 高清图路径
            routeFrom: 'Index',    // 记录路由来源，便于返回
            levelProduct: [
              {
                "name": "智能门锁",
                "series": [
                  {
                    "name": "智能门锁",
                    "product": [
                      "X1标准锁体智能锁(指纹/红古铜)", 
                      "X1霸王锁体智能锁(指纹/红古铜)", 
                      "X3霸王锁体智能锁(黑色)", 
                      "X3标准锁体智能锁(黑色)", 
                      "X50霸王锁体智能锁(红古铜)", 
                      "X50霸王锁体智能锁(太空灰)", 
                      "X50标准锁体智能锁(太空灰)", 
                      "X50标准锁体智能锁(红古铜)", 
                      "X70全自动式无锁体智能门锁(陨石黑)", 
                      "X70B1MBQ全自动标准锁体智能门锁(陨石黑)", 
                      "X70B2MBQ全自动霸王锁体智能门锁(陨石黑)", 
                      "K73标准锁体智能门锁(太空灰)", 
                      "K73标准锁体智能门锁(陨石黑)", 
                      "K73霸王锁体智能门锁(陨石黑)", 
                      "K73霸王锁体智能门锁(太空灰)",  
                      "K75标准锁体智能门锁(太空灰)",
                      "K75标准锁体智能门锁(摩卡棕)", 
                      "K75霸王锁体智能门锁(太空灰)", 
                      "K75霸王锁体智能门锁(摩卡棕)", 
                      "GNK-QA01全自动标准锁体智能门锁(鎏金黑)", 
                      "MBQ-X70B1全自动标准锁体智能门锁(陨石黑)", 
                      "GNK-ZB01B霸王锁体智能门锁(陨石黑)", 
                      "GNK-ZB01标准锁体智能门锁(陨石黑)", 
                      "GNK-QA01(B)全自动霸王锁体智能门锁(鎏金黑)", 
                      "EZ02执手式标准锁体智能门锁(陨石黑)", 
                      "EZ02执手式标准锁体智能门锁(WIFI款/陨石黑)", 
                      "HZ01执手式标准锁体智能门锁(星韵灰)", 
                      "HZ01执手式标准锁体智能门锁(WIFI款/流沙金)", 
                      "HZ01执手式标准锁体智能门锁(流沙金)", 
                      "HZ01执手式标准锁体智能门锁(陨石黑)", 
                      "HZ01执手式智能门锁(陨石黑/不含锁体)",
                      "HZ01执手式智能门锁(WIFI款/流沙金/不含锁体)", 
                      "EZ02执手式智能门锁(陨石黑/不含锁体)", 
                      "EZ02执手式智能门锁(WIFI款/陨石黑/不含锁体)", 
                      "EZ02执手式霸王锁体智能门锁(陨石黑)", 
                      "EZ02执手式霸王锁体智能门锁(WIFI款/陨石黑)", 
                      "KZ03执手式智能门锁(星韵灰/不含锁体)", 
                      "KZ03执手式智能门锁(流沙金/不含锁体)",
                      "KZ03执手式标准锁体智能门锁(星韵灰)", 
                      "KZ03执手式霸王锁体智能门锁(星韵灰)", 
                      "KZ03执手式标准锁体智能门锁(流沙金)",  
                      "GZ04执手式标准锁体智能门锁(星韵灰)", 
                      "GZ04执手式智能门锁(星韵灰/不含锁体)", 
                      "HQ01全自动半把手式标准锁体智能门锁(幻境灰/WIFI款)", 
                      "HQ01全自动半把手式无锁体智能门锁(幻境灰/WIFI款)", 
                      "HQ01全自动半把手式标准锁体智能门锁(摩卡棕/WIFI款)", 
                      "HQ01全自动半把手式无锁体智能门锁(摩卡棕/WIFI款)", 
                      "HQ01P全自动半把手式标准锁体智能门锁(幻境灰/带屏猫眼款)", 
                      "HQ01P全自动半把手式无锁体智能门锁(幻境灰/带屏猫眼款)", 
                      "HQ01P全自动半把手式标准锁体智能门锁(摩卡棕/带屏猫眼款) ", 
                      "HQ01P全自动半把手式无锁体智能门锁(摩卡棕/带屏猫眼款)", 
                      "HQ04F全自动全把手式标准锁体智能门锁(幻境灰/3D人脸款) ", 
                      "HQ04F全自动全把手式无锁体智能门锁(幻境灰/3D人脸款) ", 
                      "HQ04F全自动全把手式标准锁体智能门锁(摩卡棕/3D人脸款) ", 
                      "HQ04F全自动全把手式无锁体智能门锁(摩卡棕/3D人脸款)", 
                      "EQ02全自动半把手式标准锁体智能门锁(陨石黑/WIFI款)", 
                      "EQ02全自动半把手式霸王锁体智能门锁(陨石黑/WIFI款)", 
                      "EQ02全自动半把手式王力锁体智能门锁(陨石黑/WIFI款)", 
                      "EQ02全自动半把手式盼盼锁体智能门锁(陨石黑/WIFI款)", 
                      "EQ04P全自动全把手式标准锁体智能门锁(陨石黑/远程猫眼款)", 
                      "GZ04执手式标准锁体智能门锁(陨石黑)", 
                      "GZ04执手式智能门锁(陨石黑/不含锁体)", 
                      "GZ04执手式电子锁体智能门锁(陨石黑)",
                    ]
                  }
                ]
              },
              {
                "name": "晾衣机",
                "series": [
                  {
                    "name": "晾衣机",
                    "product": [
                      "GN-1101智能晾衣机(香槟金)", 
                      "GN-1101智能晾衣机(皓月白)", 
                      "GN-1101智能晾衣机(星空灰）", 
                      "GJJ0114Z香槟金金属伸缩款晾衣机", 
                      "GJJ0112Z星空灰金属伸缩款晾衣机", 
                      "GJJ0162Z星空灰金属伸缩杆全功能款直流晾衣机", 
                      "GJJ0164Z香槟金金属伸缩杆全功能款直流晾衣机", 
                      "GJJ0153G银色金属伸缩杆烘干款晾衣机", 
                      "GJ0212Z星空灰金属直杆基础款直流晾衣机", 
                      "GJ0214Z香槟金金属直杆基础款直流晾衣机", 
                      "GJ0311白色单杆伸缩款直流晾衣机",
                      "GJ026AZ星空灰金属伸缩杆烘干款直流晾衣机",
                      "GJ011AZ星空灰伸缩杆基础款晾衣机",
                      "GJ011AZ香槟金伸缩杆基础款晾衣机",
                      "GJ015AG银色金属伸缩杆烘干款晾衣机",
                      "GJ016AZ星空灰伸缩杆全功能款晾衣机",
                      "GJ016AZ香槟金伸缩杆全功能款晾衣机",
                      "GJ021BZ星空灰直杆基础款晾衣机",
                      "GJ021AZ星空灰伸缩杆基础款晾衣机"
                    ]
                  }
                ]
              },
              {
                "name": "智能窗帘",
                "series": [
                  {
                    "name": "智能窗帘",
                    "product": [
                      "CW11WJW智能窗帘", 
                      "GDS013AZ语音款双拼伸缩轨窗帘", 
                      "GDS013BZ语音款双拼伸缩轨窗帘", 
                      "GDZ026XQ全屋智能定制轨窗帘电机", 
                      "GDS015A多语音双拼伸缩轨窗帘", 
                      "GDS015B多语音双拼伸缩轨窗帘",
                      "GDC035A多语音一字伸缩轨窗帘(C035/1台/箱)1.7-3.0m", 
                      "GDC035B多语音一字伸缩轨窗帘(C035/1台/箱)2.2-4.0m",
                      "GDC035C多语音一字伸缩轨窗帘(C035/1台/箱)2.7-5.0m"
                    ]
                  }
                ]
              },
              {
                "name": "浴霸",
                "series": [
                  {
                    "name": "浴霸",
                    "product": [
                      "MY-B2K4060C-AD暖阳阳双电机机械款浴霸",
                      "MY-A2K4060A-AD单电机机械款浴霸(暖阳阳)",
                      "MY-B2K4060D-BD暖阳阳双电机轻触款浴霸",
                      "MY-A2K4060B-BD暖阳阳单电机轻触款浴霸",
                      "GY03AQT双电机轻触款浴霸",
                      "MY-A2K4060A-AD暖阳阳单电机机械款浴霸",
                      "GY01BQZ双电机轻触款浴霸",
                      "GY01BQZ双电机轻触款浴霸(Y01B/电商款)",
                      "GY01AJZ双电机机械款浴霸",
                      "GY01AJZ双电机机械款浴霸(Y01A/电商款)",
                      "GY05AJZ双电机机械款浴霸",
                      "GY05BQZ双电机轻触款浴霸",
                      "GY02ACZ双核舒适款浴霸",
                      "GY02ACZ双核舒适款浴霸(Y02A/电商款)",
                      "GY06AJZ双电机机械款浴霸",
                      "GY02BCZ双核标准款浴霸",
                      "GY01CCZ双电机摆页触摸款浴霸",
                      "GY08AJT单电机机械款浴霸",
                      "GY08BQT单电机遥控款浴霸",
                      "GY07BCC长出风净味款浴霸",
                      "GY07ACC长出风负离子净化款浴霸",
                      "GY09BJG单电机机械款浴霸",
                      "GY09AJG双电机机械款浴霸",
                      "GY11AJT单电机机械款浴霸",
                      "GY00AJZ双电机机械款浴霸",
                      "MY-B2K4060C-AD暖阳阳双电机机械款浴霸",
                      "GY01ECZ双电机负离子触摸款浴霸(Y01E/电商款)",
                      "GY12AJG单电机机械款浴霸(Y12A/B端)"
                    ]
                  }
                ]
              },
              {
                "name": "凉霸",
                "series": [
                  {
                    "name": "凉霸",
                    "product": [
                      "GL01AJZ机械款凉霸",
                      "GL02AYZ-01遥控款凉霸",
                      "GL02AYZ遥控款凉霸",
                      "GL03AYZ遥控摆页款凉霸",
                      "GL04AYZ照明遥控款凉霸"
                    ]
                  }
                ]
              },
              {
                "name": "风扇灯",
                "series": [
                  {
                    "name": "风扇灯",
                    "product": [ "GF00AZ/42寸隐形直流风扇灯",
                      "GF01AZ固定式吊扇灯",
                      "GF01AZ/36寸隐形风扇灯(J01/1只/箱)",
                      "GF02AZ-00豪华装饰吊扇(X01/1只/箱)",
                      "GF02AZ-00/42寸隐形风扇灯(X01/1只/箱)108W",
                      "GF03AZ/42寸隐形直流风扇灯",
                      "GF03BZ/42寸隐形直流风扇灯",
                      "GF03CZ/42寸隐形直流风扇灯",
                      "GF04AT/42寸隐形直流风扇灯",
                      "GF05AZ/36寸隐形直流风扇灯",
                      "GF06AZ/36寸金色隐形直流风扇灯",
                      "GF07AZ/46寸隐形直流风扇灯",
                      "GF06BT/36寸隐形直流风扇灯",
                      "GF06CT/36寸隐形直流风扇灯"
                    ]
                  }
                ]
              },
              {
                "name": "吸顶灯",
                "series": [
                  {
                    "name": "吸顶灯",
                    "product": ["MX-B048045C-BS三段调光圆形卧室灯(晶晨)",
                      "MX-B048045A-BS三段调光圆形卧室灯(星灿)",
                      "MX-B048045B-BS三段调光圆形卧室灯(星悦)",
                      "MX-B048G-BS三段调光卧室灯(纯皓)",
                      "MX-B048046C-BD三段调光圆形卧室灯(纯晖)",
                      "MX-B055046A-BS哑光白吸顶灯(三段调光/纯晖)",
                      "MX-C130092A-BS三段调光方形客厅灯(纯晖)",
                      "MX-B048J-BS三段调光金色圆形卧室灯(旭辉)",
                      "MX-B048046B-BD三段调光金色方形卧室灯(旭辉)",
                      "MX-C150093A-BD三段调光金色方形客厅灯(旭辉)",
                      "MX-B048K-BS三段调光灰色圆形卧室灯(旭辉)",
                      "MX-B055046B-BS三段调光灰色方形卧室灯(旭辉)",
                      "MX-C150093A-BS三段调光灰色方形客厅灯(旭辉)",
                      "MX-B048047A-BS三段调光圆形卧室灯(锦秀)",
                      "MX-C130086A-BS三段调光方形客厅灯(锦秀)",
                      "MX-D082065A-BS三段调光方形客厅灯(品轩)",
                      "MX-D128110A-BS三段调光方形客厅灯(品轩)",
                      "MX-C050055A-BE三段调光方形卧室灯(晶莹)",
                      "MX-C048A-BS三段调光圆形卧室灯(朗晨)",
                      "MX-C150A-BS三段调光方形客厅灯(朗晨)",
                      "MX-C180A-BE三段调光方形客厅灯(耀晖)",
                      "MX-C066A-AE三段调光圆形卧室灯(耀晖)",
                      "MX-C065A-BS三段调光白色方形卧室灯(耀晖)",
                      "MX-C188H-BS三段调光方形客厅灯(X01)",
                      "MX-B066H-BS三段调光圆形卧室灯(X01)",
                      "MX-B085H-BS三段调光方形卧室灯(X01)",
                      "MX-C133G-BS三段调光方形客厅灯(品宏)",
                      "MX-B088G-BS三段调光方形客厅灯(品宏)",
                      "MX-C160P-BS三段调光长方形客厅灯(X08)",
                      "MX-B068P-BS三段调光方形卧室灯(X08)",
                      "MX-B048M-BS三段调光圆形卧室灯(耀石)",
                      "MX-C128M-BS三段调光方形客厅灯(X02)",
                      "MX-C082M-BS三段调光方形卧室灯(X02)",
                      "MX-B066M-BS三段调光圆形卧室灯(X02)",
                      "MX-C150S-BS三段调光方形客厅灯(X04)",
                      "MX-B055S-BS三段调光方形卧室灯(X04)",
                      "MX-B050X-BD三段调光金色圆形卧室灯(X03)",
                      "MX-C130095B-BE方形三档调光晶灿客厅吸顶灯"
                    ]
                  }
                ]
              },
              {
                "name": "吊灯",
                "series": [
                  {
                    "name": "吊灯",
                    "product": ["MF-A136A-BS三段调光十二头吊灯(星灿)",
                      "MF-B069A-BS三段调光六头吊灯(星灿)",
                      "MF-A056C-BE配三段调色E27球泡八头吊灯(晶彩)",
                      "MF-B042C-BE配三段调色E27球泡六头吊灯(晶彩)",
                      "MF-C021C-BE配三段调色E27球泡三头餐吊灯(晶彩)",
                      "MF-C036F-BS三段调光咖色餐吊灯(颢智)",
                      "MF-A128B-BS三段调光十二头咖色吊灯(星悦)",
                      "MF-A066B-BS三段调光六头咖色吊灯(星悦)",
                      "MF-A130J-AD三环咖色客厅吊灯(X06)",
                      "MF-A066J-AD双环咖色客厅吊灯(X06)",
                      "MF-C036J-AD单环咖色餐吊灯(X06)",
                      "MX-B056J-BD三段调光双环咖色卧室灯(X06)",
                      "MF-C052K-AD异形咖色餐吊灯(X06)",
                      "MF-A150L-BD三段调光十二头灰色吊灯(X13)",
                      "MF-A088L-BD三段调光八头灰色吊灯(X13)",
                      "MF-B050L-BD三段调光五头灰色吊灯(X13)",
                      "MF-A120M-BD三段调光十二头灰色吊灯(X10)",
                      "MF-C080M-BD三段调光八头灰色吊灯(X10)",
                      "MF-B060M-BD三段调光六头灰色吊灯(X10)",
                      "MF-A120N-BD三段调光十二头金色吊灯(X12)",
                      "MF-A080N-BD三段调光八头金色吊灯(X12)",
                      "MF-B050N-BD三段调光五头金色吊灯(X12)",
                      "MF-A080P-AD八头金色吊灯(X03)",
                      "MF-C060P-AD六头金色吊灯(X03)",
                      "MF-C050P-AD长条形金色餐吊灯(X03)"
                    ]
                  }
                ]
              },
              {
                "name": "智能开关",
                "series": [
                  {
                    "name": "智能开关",
                    "product": ["G27S212智能二位开关(单火/钛金灰)",
                      "G27S312智能三位开关(单火/钛金灰)",
                      "G27S315智能三位全屋开关(无线/钛金灰)",
                      "G27S112智能一位开关(单火/钛金灰)",
                      "G27S315A智能三位情景开关(无线/钛金灰)",
                      "G27S134智能一位无线开关(钛金灰)",
                      "G27S104智能一位三极插座(钛金灰)16A",
                      "G27S223智能二三极插座(钛金灰)",
                      "G27S666网关插座",
                      "G27S666网关插座(钛金灰)",
                      "G27S315智能三位全屋开关(无线/玫瑰金)",
                      "G27S134智能一位无线开关(玫瑰金)",
                      "G27S315A智能三位情景开关(无线/玫瑰金)",
                      "G27S223智能二三极插座(玫瑰金)",
                      "G27S104智能一位三极插座(玫瑰金)16A",
                      "G27S223智能二三极插座",
                      "G27S104智能一位三极插座16A",
                      "G27S666网关插座(玫瑰金)",
                      "G27S134智能一位无线开关",
                      "G27S315智能三位全屋开关(无线)",
                      "G27S315A智能三位情景开关(无线)",
                      "G27S112智能一位开关(单火/R)",
                      "G27S112智能一位开关(单火/玫瑰金/R)",
                      "G27S212智能二位开关(单火/R)",
                      "G27S212智能二位开关(单火/玫瑰金/R)",
                      "G27S312智能三位开关(单火/R)",
                      "G27S312智能三位开关(单火/玫瑰金/R)",
                      "G27S134智能一位无线开关(皓钻黑)",
                      "G27S315A智能三位情景开关(无线/皓钻黑)",
                      "G27S223智能二三极插座(皓钻黑)",
                      "G27S104智能一位三极插座(皓钻黑)16A",
                      "G27S666网关插座(皓钻黑)",
                      "G27S112智能一位开关(单火/皓钻黑/R)",
                      "G27S212智能二位开关(单火/皓钻黑/R)",
                      "G27S312智能三位开关(单火/皓钻黑/R)"
                    ]
                  }
                ]
              }
            ],
            tableData: [],
            search: ''
          }
        },
        created() {
          let arr = [];
          this.levelProduct.forEach(function(item){
            if (item.name === '智能门锁'){
              item.series.forEach(function (args) {
                if (args.name === '智能门锁'){
                  args.product.forEach(function (param) {
                    const result  = {
                      name: param,
                      value: param
                    }
                    arr.push(result);
                  })
                }
              });
            }
          });
          this.tableData = arr
        },
        beforeRouteEnter(to,from,next){
            // 记录路由来源，便于返回
            next(vm => {
                if(from.name) {
                    vm.routeFrom = from.name
                }
            })
        },
        watch: {
            // 监听选中的产品类型，获取对应的产品系列
            selectedType: {
                handler(){
                    this.series = this.getSeriesArr(this.selectedType);
                }
            }
        },
        methods:{
          // 页面右上角 < 路由返回
          back(){
              this.$router.back();
          },
          // 获取图片地址，@/assets/propic/型号名.png
          getImgUrl(name){
              if(name.endsWith("系列")){
                  name = name.slice(0,name.length-2);
              }
              return require('@/assets/propic/'+name+'.png');
          },
          // 获取高清图片地址，@/assets/HQ/型号名-HQ.png
          getHQImgUrl(name){
              if(name.endsWith("系列")){
                  name = name.slice(0,name.length-2);
              }
              return require('@/assets/HQ/'+name+'-HQ.png');
          },
          //遍历json，返回产品类型数组
          getTypeArr() {
              let typeArr = [];
              this.levelProduct.forEach(function (item) {
                  typeArr.push(item.name);
              });
              return typeArr;
          },
          //遍历json，返回产品系列数组
          getSeriesArr(type) {
              let seriesArr = [];
              this.levelProduct.forEach(function (item) {
                  if (item.name === type) {
                      item.series.forEach(function (args) {
                          seriesArr.push(args.name);
                      });
                  }
              });
              return seriesArr;
          },
          //遍历json，返回产品型号数组
          getProductArr(type,series){
              let productArr = [];
              this.levelProduct.forEach(function(item){
                if (item.name === type){
                  item.series.forEach(function (args) {
                    if (args.name === series){
                      args.product.forEach(function (param) {
                          productArr.push(param);
                      })
                    }
                  });
                }
              });
              return productArr;
          },
          // 点击产品图片，预览打开，同时给s_product赋值
          handlePictureCardPreview(seriesName,productName){
              this.dialogVisible = true;
              this.hqImgUrl = this.getHQImgUrl(productName);
              this.s_product.type = this.selectedType;
              this.s_product.img = this.getImgUrl(productName);
              this.s_product.series = seriesName;
              this.s_product.model = productName;
          },
          // 选择产品，页面返回
          chooseProduct(){
            this.dialogVisible = false;
            if(this.s_product.model.endsWith("系列")){
                this.s_product.model = this.s_product.model.slice(0,this.s_product.model.length-2);
            }
            console.log(this.s_product)
            this.$router.push({
              name:this.routeFrom,
              params: {
                s_product: this.s_product
              }
            })
          },
          handleEdit(row) {
            this.s_product.type = this.selectedType;
            this.s_product.series = row.name;
            this.s_product.model = row.value;
            console.log(this.s_product)
            this.$router.push({
                name:this.routeFrom,
                params: {
                    s_product: this.s_product
                }
            })
          },
          selectTypeClick(tab,event){
            console.log(tab,event)
            let arr = [];
            this.levelProduct.forEach(function(item){
            if (item.name === tab.label){
                item.series.forEach(function (args) {
                  if (args.name === tab.label){
                    args.product.forEach(function (param) {
                      const result  = {
                        name: param,
                        value: param
                      }
                      arr.push(result);
                    })
                  }
                });
              }
            });
            this.tableData = arr
          }
        }
    }
</script>

<style scoped>
  .ProductInfo {
    height: 100%;
  }
  .ProductInfo > .el-tabs{
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  .prolist-list {
    margin: 0px 0px 10px 0px;
    float: left;
    font-size: 12px;
    color: #999;
  }
  .product-info {
    height: 28px;
    display:flex;
    justify-content:center;
    align-items:center;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane{
    height: 100%;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane > div{
    height: 100%;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane > div > .el-tabs{
    height: 100%;
  }
  .product-img-hq{
    width: 300px;
  }
</style>
<style>
  .ProductInfo .el-tabs__item {
    padding: 0px 10px!important;
  }
  .ProductInfo .el-tabs__content .el-tabs__content{
    height: 100%;
    /* width: 220px; */
    overflow: scroll!important;
  }
  .ProductInfo > .el-tabs> .el-tabs__content {
    position: absolute!important;
    top: 40px;
    bottom: 0px;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane > div > .el-tabs > .el-tabs__header{
    height: 500px;
  }
  .ProductInfo .el-dialog__body {
    padding: 0px!important;
  }
  .ProductInfo .el-dialog__footer {
    text-align: center;
  }
  .disflex{
    display: flex;
  }
</style>
